import React, { useEffect, useState } from 'react';
import { Button, createStyleSheet, IconButton, Input, useStyleSheet, View } from '@gopeerproject/ui-kit';
import { PortalModal } from '../../../PortalModal';
export const LinkInputModal = ({ onSave, onClose, getLink }) => {
    const styles = useStyleSheet(getStyles);
    const [title, setTitle] = useState('');
    const [value, setValue] = useState('');
    useEffect(() => {
        const { title, value } = getLink();
        setTitle(title);
        setValue(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(PortalModal, { title: 'Add link', onClose: onClose },
        React.createElement(View, { style: styles.container },
            React.createElement(Input, { icon: 'text', value: title, onChange: setTitle, placeholder: 'Text', onEnter: () => {
                    onSave(value, title);
                } }),
            React.createElement(Input, { icon: 'link', placeholder: 'Link', onChange: setValue, value: value, onEnter: () => {
                    onSave(value, title);
                }, action: React.createElement(IconButton, { value: 'copy', accent: 'neutral', type: 'secondary', size: 'xs', onPress: () => {
                        void navigator.clipboard.readText().then(setValue);
                    } }) })),
        React.createElement(View, { style: styles.footer },
            React.createElement(Button, { size: 'md', accent: 'neutral', text: 'Cancel', type: 'tertiary', onPress: onClose }),
            React.createElement(Button, { size: 'md', accent: 'default', text: 'Save', type: 'primary', onPress: () => {
                    onSave(value, title);
                } }))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        paddingHorizontal: size.K,
        paddingVertical: size.C,
        gap: size.C
    },
    footer: {
        padding: size.G,
        justifyContent: 'flex-end',
        flexDirection: 'row',
        gap: size.C
    }
}));
//# sourceMappingURL=LinkInput.js.map